"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = defer;
require("core-js/modules/es6.object.to-string.js");
require("core-js/modules/es6.promise.js");
// defer() creates a new Promise and provides a way
// to `resolve` or `reject` that promise out of scope
function defer() {
  var resolve;
  var reject;
  var promise = new Promise(function (res, rej) {
    resolve = res;
    reject = rej;
  });
  return {
    promise: promise,
    resolve: resolve,
    reject: reject
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJkZWZlciIsInJlc29sdmUiLCJyZWplY3QiLCJwcm9taXNlIiwiUHJvbWlzZSIsInJlcyIsInJlaiJdLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZGVmZXIudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHR5cGUgRGVmZXJyZWRQcm9taXNlID0ge1xuICBwcm9taXNlOiBQcm9taXNlPGFueT47XG4gIHJlc29sdmU6IHVuZGVmaW5lZCB8ICgoKSA9PiBQcm9taXNlPGFueT4pO1xuICByZWplY3Q6IHVuZGVmaW5lZCB8ICgoKSA9PiBQcm9taXNlPGFueT4pO1xufTtcblxuLy8gZGVmZXIoKSBjcmVhdGVzIGEgbmV3IFByb21pc2UgYW5kIHByb3ZpZGVzIGEgd2F5XG4vLyB0byBgcmVzb2x2ZWAgb3IgYHJlamVjdGAgdGhhdCBwcm9taXNlIG91dCBvZiBzY29wZVxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gZGVmZXIoKTogRGVmZXJyZWRQcm9taXNlIHtcbiAgbGV0IHJlc29sdmU7XG4gIGxldCByZWplY3Q7XG4gIGNvbnN0IHByb21pc2UgPSBuZXcgUHJvbWlzZSgocmVzLCByZWopID0+IHtcbiAgICByZXNvbHZlID0gcmVzO1xuICAgIHJlamVjdCA9IHJlajtcbiAgfSk7XG4gIHJldHVybiB7IHByb21pc2UsIHJlc29sdmUsIHJlamVjdCB9O1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQU1BO0FBQ0E7QUFDZSxTQUFTQSxLQUFLLEdBQW9CO0VBQy9DLElBQUlDLE9BQU87RUFDWCxJQUFJQyxNQUFNO0VBQ1YsSUFBTUMsT0FBTyxHQUFHLElBQUlDLE9BQU8sQ0FBQyxVQUFDQyxHQUFHLEVBQUVDLEdBQUcsRUFBSztJQUN4Q0wsT0FBTyxHQUFHSSxHQUFHO0lBQ2JILE1BQU0sR0FBR0ksR0FBRztFQUNkLENBQUMsQ0FBQztFQUNGLE9BQU87SUFBRUgsT0FBTyxFQUFQQSxPQUFPO0lBQUVGLE9BQU8sRUFBUEEsT0FBTztJQUFFQyxNQUFNLEVBQU5BO0VBQU8sQ0FBQztBQUNyQyJ9